var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1825_25729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.333 9.97917L11.1455 8.79167L14.1247 5H7.35384L5.68717 3.33333H15.833C16.1802 3.33333 16.4302 3.48611 16.583 3.79167C16.7358 4.09722 16.708 4.38889 16.4997 4.66667L12.333 9.97917ZM11.6663 14.0208V15.8333C11.6663 16.0694 11.5865 16.2674 11.4268 16.4271C11.267 16.5868 11.0691 16.6667 10.833 16.6667H9.16634C8.93023 16.6667 8.73231 16.5868 8.57259 16.4271C8.41287 16.2674 8.33301 16.0694 8.33301 15.8333V10.6875L1.74967 4.10417C1.5969 3.95139 1.52051 3.76042 1.52051 3.53125C1.52051 3.30208 1.5969 3.10417 1.74967 2.9375C1.91634 2.77083 2.11426 2.6875 2.34342 2.6875C2.57259 2.6875 2.77051 2.77083 2.93717 2.9375L17.083 17.0833C17.2497 17.25 17.3295 17.4444 17.3226 17.6667C17.3156 17.8889 17.2288 18.0833 17.0622 18.25C16.8955 18.4028 16.7011 18.4826 16.4788 18.4896C16.2566 18.4965 16.0622 18.4167 15.8955 18.25L11.6663 14.0208Z",
    fill: "#374E92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1825_25729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterOff);
export default __webpack_public_path__ + "static/media/icon_filter_off.3aaff699742de21d70dcc14347d29a71.svg";
export { ForwardRef as ReactComponent };